




























import Vue from 'vue';
import { Auth } from 'aws-amplify';

import ROUTE_NAMES from '@/assets/src/routes';

export default Vue.extend({
  name: 'TheNavigation',

  methods: {
    async signout() {
      await Auth.signOut();
      // We reload to clear the store and any cached components.
      // Reloading without being signed in will automatically redirect to sign in page.
      location.reload();
    },
  },

  routeNames: ROUTE_NAMES,
});
